import type { PlayerConfig } from '../config/player.config';

/**
 * Converts designer-facing jump values (height, duration) into physics values.
 *   ground jump:  apex h, ground-to-ground time T
 *   gravity g = 8h / T²,   launch velocity v₀ = 4h / T
 *   double jump:  v = √(2 g h₂) gains h₂ from the trigger height
 */
export interface JumpPhysics {
  readonly gravity: number;
  readonly jumpVelocity: number;
  readonly doubleJumpVelocity: number;
  /** Worst-case airborne time: ground jump + double jump at the apex, landing on ground (s). */
  readonly maxAirTime: number;
}

export function deriveJumpPhysics(config: PlayerConfig): JumpPhysics {
  const { jumpHeight: h, jumpDuration: t, doubleJumpHeight: h2 } = config;
  const gravity = (8 * h) / (t * t);
  const jumpVelocity = (4 * h) / t;
  const doubleJumpVelocity = Math.sqrt(2 * gravity * h2);
  const timeToApex = jumpVelocity / gravity;
  const secondRise = doubleJumpVelocity / gravity;
  const fallFromTop = Math.sqrt((2 * (h + h2)) / gravity);
  return { gravity, jumpVelocity, doubleJumpVelocity, maxAirTime: timeToApex + secondRise + fallFromTop };
}
